<button
  mat-flat-button
  class="back-button"
  (click)="goBack()"
  tabindex="0"
  [attr.aria-label]="'general.back' | translate">
  <span class="odilo-icon" aria-hidden="true">navigate_before</span>
  <span aria-hidden="true">{{ 'general.back' | translate }}</span>
</button>

<div class="topics-component" *ngIf="topics">
  <h1 tabindex="0">{{ topics.label }}</h1>

  <div class="thema-component__list">
    <mat-accordion displayMode="flat" multi="true">
      <mat-expansion-panel [expanded]="true" *ngFor="let firstLevel of topics.firstLevel" class="list__item">
        <mat-expansion-panel-header class="list__item__title" tabindex="0" collapsedHeight="48px" expandedHeight="48px">
          <h2
            (keydown.enter)="open(firstLevel)"
            (keydown.space)="open(firstLevel)"
            (click)="open(firstLevel)">
            {{ firstLevel.label }}
        </h2>
        </mat-expansion-panel-header>

        <div class="list__item__content" *ngIf="firstLevel.nextLevel">
          <div
            class="content__name"
            *ngFor="let secondLevel of firstLevel.nextLevel"
            (keydown.enter)="open(secondLevel)"
            (keydown.space)="open(secondLevel)"
            (click)="open(secondLevel)"
            tabindex="0">
            <p class="content__name__title">{{ secondLevel.label }}</p>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
